import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import en from './en.json';

let savedLang = 'en';

if (typeof window !== 'undefined') {
  savedLang = localStorage.getItem('lang') || 'en';
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: savedLang,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export { i18n };
